import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ImportMaps } from 'src/app/models/importmaps.model';
import { Plant } from 'src/app/models/plant.model';
import { ImportmapsService } from 'src/app/services/importmaps/importmaps.service';
import { PlantsService } from 'src/app/services/plants/plants.service';

@Component({
  selector: 'app-list-import-maps',
  templateUrl: './list-import-maps.component.html',
  styleUrls: ['./list-import-maps.component.scss'],
})
export class ListImportMapsComponent {
  dtoptions: DataTables.Settings = {};
  PlantId: string;
  importMaps: ImportMaps[] = [];
  plants: Plant[] = [];
  showTable = false;
  plantDetails: Plant = new Plant();
  ImportMapsIdList: number[] = [];

  constructor(
    private plantService: PlantsService,
    private importmapsService: ImportmapsService,
    private toastr: ToastrService
  ) {}

  getSelectedId(e) {
    this.showTable = true;
    this.PlantId = e.target.value;
    this.GetImportMaps(this.PlantId);
    this.plantService.getPlant(this.PlantId).subscribe({
      next: (response) => {
        this.plantDetails = response;
        console.log(this.plantDetails);
      },
    });
  }

  GetImportMaps(PlantId) {
    this.importmapsService.GetImportMapsByPlantId(PlantId).subscribe(
      (response: ImportMaps[]) => {
        this.importMaps = response;
        console.log(this.importMaps);
      },

      (error: any) => {
        console.log('error list');
      }
    );
  }

  selectednoOtherUser(ImmapId) {
    if (this.ImportMapsIdList.includes(ImmapId)) {
      let Index = this.ImportMapsIdList.indexOf(ImmapId);
      this.ImportMapsIdList.splice(Index, 1);
    } else {
      this.ImportMapsIdList.push(ImmapId);
    }
    console.log(this.ImportMapsIdList);
  }

  TheDeleter() {
    const confirmDelete = confirm(
      'Are you sure you want to delete Selected Import Maps?'
    );

    if (!confirmDelete) {
      return; 
    }
    
    console.log(this.ImportMapsIdList);
    this.importmapsService
      .DeleteImportMaps(this.PlantId, this.ImportMapsIdList)
      .subscribe({
        next: (List) => {
          this.toastr.error('Deleted Import Maps Successfully.', 'Information');
          this.ImportMapsIdList = [];
          this.GetImportMaps(this.PlantId);
        },
      });
  }

  ngOnInit(): void {
    this.dtoptions = {
      pagingType: 'full_numbers',
    };

    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
      
    }
    else
    {
    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }

  //subscribe to selected plant changes to update the table accordingly
    this.plantService.selectedPlant$.subscribe(plantId => {
      if (plantId) {
        this.getSelectedId({
          target: {
            value: plantId
          }
        });
      }
    });

}
}
